import React, { Component } from 'react';

var HtmlToReactParser = require('html-to-react').Parser;

export default class extends Component {
    render() {
        var {content, tenantCode } = this.props;
        
        return (
            <div className="footer">
                <div className="link">
                    <div className="contains">
                    </div>
                </div>
                <div className="info">
                    <div className="contains"> 
                        <p>{new HtmlToReactParser().parse(content.title)}</p>
                        <div className="logo-box">
                            <a href={"https://donus.org?utm_source=donusPayStandard&utm_medium=ownedMedia&utm_content=footerLogo&utm_campaign=20180327&utm_term=" + tenantCode} target="_blank" rel="noreferrer">
                                <img src={require("../img/common/donuspay.png")} alt="Powered by DONUS PAY" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js